/**
 * API Configuration
 * Centralized configuration for API endpoints
 */

// Get the API URL from environment variables or use default
export const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

// Helper function to create full API URLs
export const getApiUrl = (endpoint: string): string => {
  // Remove leading slash if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};

// Export for direct use
export default API_BASE_URL;